import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon20: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        d="M7 0a7 7 0 0 1 6.295 10.064l6.035 6.035a2.284 2.284 0 1 1-3.23 3.231l-6.037-6.034A7 7 0 1 1 7 0Zm3.957 12.775 5.85 5.849a1.285 1.285 0 0 0 1.816-1.817l-5.849-5.849a7.054 7.054 0 0 1-1.817 1.817ZM7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1Zm-.023 1.725a.5.5 0 0 1 .5.5l.001.465c.27.05.539.131.802.235.277.109.491.219.62.298a.5.5 0 1 1-.52.854 3.283 3.283 0 0 0-.466-.222 2.958 2.958 0 0 0-1.062-.225c-.684 0-1.147.321-1.147.72 0 .454.37.727 1.529 1.19l.116.046c1.483.591 2.042.99 2.042 1.949 0 1.025-.751 1.644-1.914 1.782l-.001.457a.499.499 0 1 1-1 0v-.452a3.454 3.454 0 0 1-1.147-.318 2.083 2.083 0 0 1-.584-.396.5.5 0 0 1 .722-.692c.031.032.129.106.299.189.309.15.702.242 1.189.242.97 0 1.436-.304 1.436-.812 0-.352-.332-.59-1.413-1.02l-.116-.047C5.317 6.852 4.705 6.4 4.705 5.35c0-.933.772-1.569 1.772-1.696v-.429a.5.5 0 0 1 .5-.5Z"
      />
    </Svg>
  )
}
